/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Awaiting_Run_Approval_NoticeInputs */



/**
* | output |
* | --- |
* | "This chat's agent run is waiting for an approval. New messages are possible once it has been decided." |
*
* @param {Chat_Awaiting_Run_Approval_NoticeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_awaiting_run_approval_notice = /** @type {((inputs?: Chat_Awaiting_Run_Approval_NoticeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Awaiting_Run_Approval_NoticeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Der Agentenlauf dieses Chats wartet auf eine Freigabe. Neue Nachrichten sind möglich, sobald darüber entschieden ist.")
	return /** @type {LocalizedString} */ ("This chat's agent run is waiting for an approval. New messages are possible once it has been decided.")
});